import Common from '@vendor/js/common';
import { ConfirmSwal, SuccessSwal } from '@vendor/libs/sweetalert2/sweetalert2';
import { i18n } from '@vendor/libs/lang/lang';
import { Spinner } from '@vendor/js/spinner';
import { Api } from '@vendor/js/api';
const _BillingCyclesShowHandler = (function () {
    const handleMembersTable = () => {
        const table = $('[data-app-members="table"]');
        if (table.length) {
            window.handleCheckbox(table.DataTable());
        }
    };
    const initGeneratePaymentModal = (loadDataUrl) => {
        Common.handleModalForm('generate_payment', {
            loadData: true,
            loadDataUrl,
            loadDataUrlReplaceId: true,
        });
    };
    const initUpdatePaidAmountModal = (loadDataUrl) => {
        Common.handleModalForm('update_paid_amount', {
            loadData: true,
            loadDataUrl,
            loadDataUrlReplaceId: true,
        });
    };
    const initBulkPaymentGenerate = (generateUrl, entityId) => {
        const table = $('[data-app-members="table"]');
        const button = $('[data-app-action="bulk_generate"]');
        button.on('click', function () {
            ConfirmSwal.fire({
                text: i18n.trans('models/billing_cycles.actions.bulk_generate.confirm'),
                input: 'checkbox',
                inputPlaceholder: i18n.trans('models/billing_cycles.actions.bulk_generate.is_send_message_enabled'),
                customClass: {
                    input: 'd-flex flex-column text-center',
                    denyButton: 'btn btn-warning-light me-2',
                    confirmButton: 'btn btn-primary',
                },
            }).then(async (response) => {
                const checkboxValue = response.value == 1;
                if (response.isConfirmed) {
                    const spinner = new Spinner();
                    try {
                        const response = await Api.post(generateUrl, {
                            entity_id: entityId,
                            is_send_message_enabled: checkboxValue,
                        });
                        if (response) {
                            SuccessSwal.fire({
                                text: i18n.trans(response.message ??
                                    'models/applications.pages.show.cancel_success'),
                            }).then(() => {
                                if (response.redirect) {
                                    window.location.href = response.redirect;
                                }
                            });
                        }
                    }
                    catch (err) {
                        Common.handleErrorResponse(err);
                    }
                    finally {
                        spinner.destroy();
                    }
                }
            });
        });
    };
    return {
        // Public functions
        init: function () {
            handleMembersTable();
            $('[name="is_paid"]').on('change', function () {
                $('[name="paid_amount"]').attr('disabled', $(this).is(':checked'));
            });
        },
        initGeneratePaymentModal,
        initBulkPaymentGenerate,
        initUpdatePaidAmountModal,
    };
})();
window.BillingCyclesShowHandler = _BillingCyclesShowHandler;
